module.exports = __webpack_public_path__ + "img/wulianwang (1).3c08be29.png";